/**
 * Function to format sipo date
 * @param {string} dateString the date string
 * @returns {string} the result
 */
export const transformSipoDate = (dateString = ''): string => {
  if (dateString === '00000000') {
    return '0001-01-01';
  }
  if (dateString === '99999999') {
    return '2999-12-31';
  }
  return dateString;
};
